import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  loggedin: Boolean;
  username: string;
  ErrMess: Error;
  credentials: any;
  constructor(private authService: AuthService){
   }

  ngOnInit() {
    this.authService.loadUserCredentials();
    this.loggedin = this.authService.isLoggedIn();
    this.username = this.authService.getUsername();
    //console.log(this.loggedin, this.username);
  }

  Logout(){
    this.authService.logOut();
  }

}
